import React from "react";

const NewFileIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg width={32} height={34} viewBox="0 0 32 34" fill="none" {...props}>
    <g stroke="#8065C9" strokeWidth={2} strokeLinecap="round">
      <path
        d="M17.586 1.167h.432c5.163 0 7.745 0 9.538 1.263.514.362.97.79 1.354 1.274 1.343 1.688 1.343 4.118 1.343 8.978v4.03c0 4.692 0 7.038-.743 8.911-1.194 3.012-3.718 5.388-6.918 6.511-1.99.7-4.483.7-9.468.7-2.849 0-4.273 0-5.41-.4-1.83-.642-3.272-2-3.954-3.72-.424-1.072-.424-2.412-.424-5.093V17"
        strokeLinejoin="round"
      />
      <path
        d="M30.247 17a5.278 5.278 0 01-5.277 5.278c-1.054 0-2.297-.185-3.322.09a2.639 2.639 0 00-1.866 1.866c-.275 1.025-.09 2.267-.09 3.322a5.278 5.278 0 01-5.278 5.277"
        strokeLinejoin="round"
      />
      <path d="M14.417 7.5H1.75m6.333-6.333v12.666" />
    </g>
  </svg>
);
export default NewFileIcon;
